import { useEffect, useState } from 'react'
import CategoryService from '../../../common/category/core/service'
import { TYPES_DISCOUNT } from '../../../utils/common'

export const useGetDiscountDouble = (disable = false) => {
  const [discountPackage, setDiscountPackage] = useState({})
  const [discountSub, setDiscountSub] = useState({})

  const getDiscount = async () => {
    const pack = await CategoryService.getDiscountOrder({
      DiscountObjectTypes: `${TYPES_DISCOUNT.SNPOrder},${TYPES_DISCOUNT.Package}`,
    })
    const subscription = await CategoryService.getDiscountOrder({
      DiscountObjectTypes: `${TYPES_DISCOUNT.SNPOrder},${TYPES_DISCOUNT.Subscription}`,
    })

    if (pack.success) setDiscountPackage(pack.data?.[0])
    if (subscription.success) setDiscountSub(subscription.data?.[0])
  }

  useEffect(() => {
    if (!disable) {
      getDiscount()
    }
  }, [])

  return {
    discountSub,
    discountPackage,
  }
}
